/**
 * LVMH specific configuration.
 *
 * This will be merged with `src/config/index.ts`
 */
const supportedLanguages = [
  "en",
  "en-US",
  "fr",
  "es",
  "de",
  "it",
  "nl",
  "sv",
  "cs",
  "ar",
  "ja",
  "zh-Hant",
  "zh-Hans",
  "ko",
  "th",
  "ru",
  "uk",
  "hi"
];

export default {
  id: "lvmh",
  languages: {
    supportedLanguages,
    loadPath:
      "https://sdo-demo-main-166ce2cf6b6-16f0d81c8be.secure.force.com/wservices/services/apexrest/i18n/{{lng}}/{{ns}}"
  },
  customise: {
    customer: {
      enableAdditionalInfo: true,
      enableAdvisorForm: true,
      enableRemoteCustomer: true
    },
    fields: {
      customFields: ["preferencesCategories", "preferencesContact"]
    }
  },
  zones: {
    worldwide: {
      languages: supportedLanguages,
      supportedLanguages
    },
    europe: {
      languages: ["en", "fr", "es"],
      supportedLanguages: ["en", "fr", "es"]
    },
    africa: {
      languages: ["en", "fr", "es"],
      supportedLanguages: ["en", "fr", "es"]
    },
    asia: {
      languages: ["ja", "zh-Hans", "zh-Hant", "ko"],
      supportedLanguages: ["en", "ja", "zh-Hans", "zh-Hant"]
    },
    jp: {
      languages: ["ja"],
      supportedLanguages: ["en", "ja"]
    },
    apac: {
      languages: ["ja", "zh-Hans", "zh-Hant"],
      supportedLanguages: ["en", "ja", "zh-Hans", "zh-Hant"]
    },
    americas: {
      languages: ["en", "es"],
      supportedLanguages: ["en", "es"]
    },
    middleEast: {
      languages: ["en", "ar"],
      supportedLanguages: ["en", "ar"]
    }
  },
  services: {
    googleAnalytics: {
      options: {},
      customise: {
        dimensions: {
          traceToken: "dimension1",
          salesPersonId: "dimension2",
          storeId: "dimension3",
          storeCountry: "dimension4",
          attempt: "dimension5",
          requestId: "dimension6",
          storeName: "dimension7",
          countryName: "dimension8"
        },
        metrics: {}
      }
    }
  }
};
